/* Titan Landing — comportamiento de las secciones "tl-" (sin dependencias)
   Funciona en la tienda y dentro del editor de Shopify: cuando cambias una foto o un
   texto, la sección se recarga y aquí se vuelve a activar (eventos shopify:section:*). */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  var design = !!(window.Shopify && window.Shopify.designMode);

  // Cada componente guarda aquí cómo limpiarse (timers, observadores) por si el editor lo recarga
  function addCleanup(el, fn) { (el._tlClean = el._tlClean || []).push(fn); }
  function cleanup(scope) {
    [scope].concat($$('*', scope)).forEach(function (el) {
      if (el._tlClean) { el._tlClean.forEach(function (fn) { try { fn(); } catch (e) {} }); el._tlClean = null; el._tlInit = false; }
    });
  }
  function once(el) { if (el._tlInit) return false; el._tlInit = true; return true; }
  function onView(el, cb, opts) {
    if (!hasIO) { cb(true); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { cb(x.isIntersecting, x); }); }, opts || { threshold: 0.15 });
    io.observe(el); addCleanup(el, function () { io.disconnect(); });
  }
  function playV(v) { if (!v) return; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }

  /* ---------- Hero: imágenes que rotan solas con fundido + zoom lento ---------- */
  function initHero(scope) {
    $$('[data-tl-hero]', scope).forEach(function (hero) {
      if (!once(hero)) return;
      function fit() {
        hero.style.removeProperty('--tl-hero-h');
        var top = hero.getBoundingClientRect().top + window.scrollY;
        if (top > 0 && top < 160) hero.style.setProperty('--tl-hero-h', 'calc(100svh - ' + Math.round(top) + 'px)');
      }
      fit(); window.addEventListener('resize', fit);
      addCleanup(hero, function () { window.removeEventListener('resize', fit); });

      var media = $('[data-tl-hero-media]', hero);
      var slides = $$('.tl-hero__ph', media);
      var bars = $$('.tl-hero__bars i', hero);
      var ms = parseInt(hero.getAttribute('data-interval'), 10) || 2500;
      var i = Math.max(0, slides.findIndex ? slides.findIndex(function (s) { return s.classList.contains('on'); }) : 0);
      var timer = null, inView = true, paused = false;
      if (!slides.length) return;

      function vid(s) { return s ? $('video', s) : null; }
      function show(n, instant) {
        n = (n + slides.length) % slides.length;
        if (n === i && slides[n].classList.contains('on')) return;
        var prev = slides[i], cur = slides[n];
        if (prev !== cur) {
          prev.classList.remove('on'); prev.classList.add('was');
          var pv = vid(prev); if (pv) pv.pause();
          setTimeout(function () { if (!prev.classList.contains('on')) prev.classList.remove('was'); }, 700);
        }
        if (instant) hero.classList.remove('tl-ready');
        cur.classList.remove('was'); void cur.offsetWidth; cur.classList.add('on');
        if (instant) requestAnimationFrame(function () { hero.classList.add('tl-ready'); });
        var cv = vid(cur); if (cv) { cv.currentTime = 0; playV(cv); }
        bars.forEach(function (b, k) { b.classList.toggle('done', k < n); b.classList.remove('on'); });
        if (bars[n]) { void bars[n].offsetWidth; bars[n].classList.add('on'); }
        i = n;
      }
      function stop() { clearInterval(timer); timer = null; }
      function start() { stop(); if (slides.length > 1 && !reduce && inView && !paused && !document.hidden) timer = setInterval(function () { show(i + 1); }, ms); }
      function onVis() { if (document.hidden) stop(); else start(); }

      slides.forEach(function (s, k) { s.classList.toggle('on', k === i); });
      if (bars[i]) bars[i].classList.add('on');
      playV(vid(slides[i]));
      // Recién después de mostrar la primera foto activamos los fundidos
      requestAnimationFrame(function () { hero.classList.add('tl-ready'); });

      // Tocar a la izquierda = anterior, a la derecha = siguiente; deslizar también funciona
      var sx = null, swiped = false;
      media.addEventListener('click', function (e) {
        if (swiped) { swiped = false; return; }
        if (slides.length < 2 || design) return;
        var r = media.getBoundingClientRect();
        show((e.clientX - r.left) < r.width * 0.3 ? i - 1 : i + 1); start();
      });
      media.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      media.addEventListener('touchend', function (e) {
        if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; sx = null;
        if (Math.abs(dx) > 45) { swiped = true; show(dx < 0 ? i + 1 : i - 1); start(); }
      }, { passive: true });

      onView(hero, function (vis) { inView = vis; if (vis) start(); else stop(); }, { threshold: 0.2 });
      document.addEventListener('visibilitychange', onVis);
      addCleanup(hero, function () { stop(); document.removeEventListener('visibilitychange', onVis); });

      // En el editor: al tocar una foto en la barra lateral, se muestra esa y se pausa la rotación
      hero._tlGo = function (blockEl) {
        var n = slides.indexOf(blockEl); if (n < 0) return false;
        paused = true; stop(); show(n, true); return true;
      };
      hero._tlResume = function () { paused = false; start(); };
      start();
    });
  }

  /* ---------- Fondo rotativo del escenario (Beneficios) ---------- */
  function initStageBg(scope) {
    $$('[data-tl-rotate]', scope).forEach(function (bg) {
      if (!once(bg)) return;
      var slides = $$('.tl-stage__ph', bg);
      bg.classList.add('tl-ready');
      if (slides.length < 2) return;
      var ms = parseInt(bg.getAttribute('data-interval'), 10) || 2000;
      var i = 0, timer = null, inView = true;

      function show(n) {
        n = (n + slides.length) % slides.length;
        if (n === i) return;
        var prev = slides[i], cur = slides[n];
        prev.classList.remove('on'); prev.classList.add('was');
        setTimeout(function () { if (!prev.classList.contains('on')) prev.classList.remove('was'); }, 700);
        cur.classList.remove('was'); void cur.offsetWidth; cur.classList.add('on');
        i = n;
      }
      function stop() { clearInterval(timer); timer = null; }
      function start() { stop(); if (!reduce && inView && !document.hidden) timer = setInterval(function () { show(i + 1); }, ms); }
      function onVis() { if (document.hidden) stop(); else start(); }

      slides.forEach(function (s, k) { s.classList.toggle('on', k === 0); s.classList.remove('was'); });
      onView(bg, function (vis) { inView = vis; if (vis) start(); else stop(); }, { threshold: 0.2 });
      document.addEventListener('visibilitychange', onVis);
      addCleanup(bg, function () { stop(); document.removeEventListener('visibilitychange', onVis); });
    });
  }

  /* ---------- Cinta de reseñas del hero ----------
     La cinta se alimenta de la sección "Reseñas (oscuro)" de la misma página: frase,
     nombre, ciudad, sello de verificada, más la nota y la cantidad del recuadro grande.
     Si esa sección no está en la plantilla, se quedan los bloques de respaldo del hero. */
  function syncTicker(t) {
    var box = $('.tl-tick__q', t);
    if (!box) return;
    if (t.hasAttribute('data-tl-sync')) {
      var list = $('[data-tl-rvs]');
      var cards = list ? $$('.tl-rv', list) : [];
      if (cards.length) {
        var frag = document.createDocumentFragment();
        cards.forEach(function (c) {
          var quote = txt($('p', c)) || txt($('.tl-rv__t', c));
          if (!quote) return;
          var city = txt($('.tl-rv__n small', c)).split('·')[0].trim();
          var who = [txt($('.tl-rv__n b', c)), city].filter(Boolean).join(' · ');
          var sp = document.createElement('span');
          var q = document.createElement('q'); q.textContent = quote; sp.appendChild(q);
          var sm = document.createElement('small'); sm.textContent = who;
          if ($('.tl-rv__ok', c)) {
            if (who) sm.appendChild(document.createTextNode(' · '));
            var ok = document.createElement('b'); ok.textContent = '✓ Compra verificada'; sm.appendChild(ok);
          }
          sp.appendChild(sm); frag.appendChild(sp);
        });
        if (frag.childNodes.length) { box.innerHTML = ''; box.appendChild(frag); }

        // Nota y cantidad: las mismas del recuadro grande de reseñas
        var sum = $('.tl-rsum__n'), head = $('.tl-tick__h span', t);
        if (sum && head) {
          var rating = txt($('strong', sum)), count = txt($('small', sum));
          if (rating) {
            head.innerHTML = '';
            var ri = document.createElement('i'); ri.textContent = rating; head.appendChild(ri);
            if (count) head.appendChild(document.createTextNode(' · ' + count));
            t.setAttribute('aria-label', 'Ver reseñas: ' + rating + ' de 5, ' + count);
          }
        }
      }
    }
    var spans = $$('.tl-tick__q > span', t);
    spans.forEach(function (s, n) { s.classList.toggle('on', n === 0); });
    // Sin reseñas en ningún lado, la cinta no se muestra
    t.style.display = spans.length ? '' : 'none';
  }

  function initTicker(scope) {
    $$('[data-tl-ticker]', scope).forEach(function (t) {
      if (!once(t)) return;
      var tm = null;
      function list() { return $$('.tl-tick__q > span', t); }
      function next() {
        var it = list(); if (it.length < 2) return;
        var k = 0;
        it.forEach(function (s, n) { if (s.classList.contains('on')) k = n; });
        it[k].classList.remove('on');
        var nx = (k + 1) % it.length;
        void it[nx].offsetWidth; it[nx].classList.add('on');
      }
      function stop() { clearInterval(tm); tm = null; }
      function start() { stop(); if (!reduce && list().length > 1) tm = setInterval(next, 3200); }
      // El editor llama a esto cuando se recarga la sección de reseñas
      t._tlSync = function () { syncTicker(t); start(); };
      syncTicker(t);
      onView(t, function (vis) { if (vis) start(); else stop(); });
      addCleanup(t, function () { stop(); });
    });
  }
  function resyncTickers() { $$('[data-tl-ticker]').forEach(function (t) { if (t._tlSync) t._tlSync(); }); }

  /* ---------- Antes y después: pasa los casos solo cada X segundos ----------
     Si el cliente desliza con el dedo, se pausa unos segundos y luego sigue. */
  function initBA(scope) {
    $$('[data-tl-ba]', scope).forEach(function (ba) {
      if (!once(ba)) return;
      var track = $('.tl-ba__track', ba) || ba;
      var cards = $$('.tl-ba__card', track);
      var ms = parseInt(ba.getAttribute('data-auto'), 10) || 0;
      if (!ms || cards.length < 2 || reduce) return;
      var lastUser = 0, inView = false;

      function to(n) {
        var c = cards[n]; if (!c) return;
        track.scrollTo({ left: c.offsetLeft - (track.clientWidth - c.offsetWidth) / 2, behavior: 'smooth' });
      }
      function current() {
        var center = track.scrollLeft + track.clientWidth / 2, cur = 0, best = 1e9;
        cards.forEach(function (c, k) { var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - center); if (d < best) { best = d; cur = k; } });
        return cur;
      }
      function go() {
        if (!inView || document.hidden) return;
        if (Date.now() - lastUser < 6000) return;
        if (track.scrollWidth <= track.clientWidth + 4) return;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        var nx = atEnd ? 0 : current() + 1;
        if (nx >= cards.length) nx = 0;
        to(nx);
      }

      ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
        track.addEventListener(ev, function () { lastUser = Date.now(); }, { passive: true });
      });
      var tm = setInterval(go, ms);
      onView(ba, function (vis) { inView = vis; }, { threshold: 0.35 });
      addCleanup(ba, function () { clearInterval(tm); });

      // En el editor: al tocar un caso en la barra lateral, se muestra ese y se pausa el avance
      ba._tlGo = function (blockEl) {
        var c = blockEl.closest ? blockEl.closest('.tl-ba__card') : null;
        if (!c) return false;
        lastUser = Date.now() + 60000;
        to(cards.indexOf(c)); return true;
      };
    });
  }

  /* ---------- Hoja de reseñas (se busca al abrir, así sobrevive a recargas del editor) ---------- */
  var lastFocus = null;
  function sheetEl() { return $('[data-tl-sheet]'); }
  function openSheet() {
    var sheet = sheetEl();
    if (!sheet) { var r = $('[data-tl-rvs]'); if (r) r.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
    lastFocus = document.activeElement;
    sheet.hidden = false; document.body.classList.add('tl-lock');
    requestAnimationFrame(function () { requestAnimationFrame(function () { sheet.classList.add('is-on'); }); });
    var x = $('.tl-sheet__x', sheet); if (x) setTimeout(function () { x.focus(); }, 60);
  }
  function closeSheet() {
    var sheet = sheetEl();
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-on'); document.body.classList.remove('tl-lock');
    setTimeout(function () { sheet.hidden = true; }, 380);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function initSheetOnce() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-sheet-open]')) { e.preventDefault(); openSheet(); }
      else if (e.target.closest('[data-sheet-close]')) { e.preventDefault(); closeSheet(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
  }

  /* ---------- Aparición al hacer scroll ---------- */
  function initReveal(scope) {
    var els = $$('.tl-reveal', scope).filter(function (e) { return !e.classList.contains('in'); });
    if (!hasIO || reduce || design) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });
    els.forEach(function (e) { io.observe(e); });
    // Seguro: si por algún motivo no se disparó, que nada quede invisible
    setTimeout(function () { els.forEach(function (e) { var r = e.getBoundingClientRect(); if (r.top < window.innerHeight) e.classList.add('in'); }); }, 2500);
  }

  /* ---------- Videos de creadores ---------- */
  function initCreators(scope) {
    $$('[data-tl-igs]', scope).forEach(function (igs) {
      if (!once(igs)) return;
      var boxes = $$('[data-tl-vid]', igs);
      var cards = $$('.tl-igc', igs);
      var auto = parseInt(igs.getAttribute('data-auto'), 10) || 0;
      var lastUser = 0, sectionVisible = false;

      function muteAll(except) {
        boxes.forEach(function (b) {
          var v = $('video', b); if (b === except) return;
          b.classList.remove('on'); if (v) v.muted = true;
        });
      }
      boxes.forEach(function (box) {
        var v = $('video', box);
        if (!v) { box.classList.add('ok'); return; }
        v.muted = true; v.setAttribute('playsinline', ''); v.setAttribute('muted', '');
        if (v.poster) box.classList.add('ok');
        ['loadeddata', 'playing'].forEach(function (ev) { v.addEventListener(ev, function () { box.classList.add('ok'); }); });
        var btn = $('.tl-igc__play', box);
        if (btn) btn.addEventListener('click', function () {
          lastUser = Date.now();
          if (box.classList.contains('on')) { box.classList.remove('on'); v.muted = true; return; }
          muteAll(box); box.classList.add('on'); v.muted = false; v.currentTime = 0; playV(v);
        });
        // Solo se reproducen los videos que se ven en pantalla
        onView(box, function (vis) {
          if (vis) { playV(v); }
          else { v.pause(); if (box.classList.contains('on')) { box.classList.remove('on'); v.muted = true; } }
        }, { threshold: 0.6 });
      });

      ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) { igs.addEventListener(ev, function () { lastUser = Date.now(); }, { passive: true }); });

      // Rotación automática: avanza una tarjeta cada X s mientras nadie la toca
      if (auto > 0 && cards.length > 1 && !reduce) {
        onView(igs, function (vis) { sectionVisible = vis; }, { threshold: 0.5 });
        var tm = setInterval(function () {
          if (!sectionVisible || document.hidden) return;
          if (Date.now() - lastUser < 8000) return;
          if (igs.scrollWidth <= igs.clientWidth + 4) return;
          if ($('.tl-igc__v.on', igs)) return;
          var center = igs.scrollLeft + igs.clientWidth / 2, cur = 0, best = 1e9;
          cards.forEach(function (c, k) { var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - center); if (d < best) { best = d; cur = k; } });
          var atEnd = igs.scrollLeft + igs.clientWidth >= igs.scrollWidth - 4;
          var nx = atEnd ? 0 : cur + 1; if (nx >= cards.length) nx = 0;
          var c = cards[nx];
          igs.scrollTo({ left: c.offsetLeft - (igs.clientWidth - c.offsetWidth) / 2, behavior: 'smooth' });
        }, auto);
        addCleanup(igs, function () { clearInterval(tm); });
      }
      igs._tlGo = function (blockEl) {
        var c = blockEl.closest('.tl-igc'); if (!c) return false;
        lastUser = Date.now() + 60000;
        igs.scrollTo({ left: c.offsetLeft - (igs.clientWidth - c.offsetWidth) / 2, behavior: 'smooth' }); return true;
      };
    });
  }

  /* ---------- Barra fija (busca los elementos en cada scroll: sobrevive al editor) ---------- */
  function checkSticky() {
    var bar = $('[data-tl-stk]');
    document.body.classList.toggle('has-tlstk', !!bar);
    if (!bar) return;
    var hero = $('[data-hero-cta]');
    var show = hero ? hero.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
    if (document.body.classList.contains('tl-lock')) show = false;
    if (design && bar.classList.contains('tl-force')) show = true;
    bar.classList.toggle('show', show);
  }

  /* ---------- Barra de progreso de lectura ---------- */
  function updProgress() {
    var p = $('[data-tl-sprog]'); if (!p) return;
    var h = document.documentElement.scrollHeight - window.innerHeight;
    p.style.transform = 'scaleX(' + (h > 0 ? Math.min(1, window.scrollY / h) : 0) + ')';
  }

  /* ---------- Formularios COD: EasySell y Releasit ----------
     EasySell: su app abre el formulario sola al tocar cualquier botón con la clase
     "es-popup-button-overwrite" (la ponemos desde Liquid).
     Releasit: el tema presiona por detrás el botón que Releasit inserta en la página.
     En modo "detecta solo" los botones llevan las dos cosas y aquí se decide cuál usar. */
  function hasApp(re) {
    return [].some.call(document.querySelectorAll('script[src],link[href]'), function (x) { return re.test(x.src || x.href || ''); });
  }
  function easyActive() {
    return !!(hasApp(/easysell|easy-order-form|tyslo/i) || document.getElementById('es-popup-button') ||
      document.querySelector('.es-popup-button, .es-form-button, [id^="es-form"]:not(#es-form-hook), [class*="es-popup"]:not(.es-popup-button-overwrite)'));
  }
  function rsiButton() {
    var sel = document.body.getAttribute('data-rsi-sel') || '._rsi-buy-now-button';
    var list;
    try { list = $$(sel); } catch (e) { list = $$('._rsi-buy-now-button'); }
    list = list.filter(function (b) { return !b.hasAttribute('data-tl-cod') && !b.hasAttribute('data-tl-es'); });
    return list[0] || null;
  }
  function rsiOpen() { var m = document.getElementById('_rsi-cod-form-modal'); return !!(m && (m.classList.contains('_rsi-cod-form-modal-open') || getComputedStyle(m).display !== 'none')); }
  /* EasySell en modo "incrustado" (Embedded): no tiene ventana propia y dibuja el formulario
     en el espacio oculto del tema. En ese caso lo mostramos dentro de una ventana del tema. */
  function esEmbedded() {
    var c = document.getElementById('easysell');
    if (!c || c.closest('#easysell-modal')) return null;
    return c;
  }
  var esm = null, esmLast = null;
  function esmClose() {
    if (!esm || esm.hidden) return;
    esm.classList.remove('is-on'); document.body.classList.remove('tl-lock');
    setTimeout(function () { esm.hidden = true; }, 300);
    if (esmLast && esmLast.focus) esmLast.focus();
  }
  function esmOpen(form) {
    if (!esm) {
      esm = document.createElement('div');
      esm.className = 'tl-esm'; esm.hidden = true;
      esm.innerHTML = '<div class="tl-esm__bd" data-esm-close></div><div class="tl-esm__p" role="dialog" aria-modal="true" aria-label="Formulario de pedido"><button type="button" class="tl-esm__x" data-esm-close aria-label="Cerrar">×</button><div class="tl-esm__b"></div></div>';
      document.body.appendChild(esm);
      esm.addEventListener('click', function (e) { if (e.target.closest('[data-esm-close]')) esmClose(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') esmClose(); });
    }
    var body = $('.tl-esm__b', esm);
    if (form.parentElement !== body) body.appendChild(form);
    esmLast = document.activeElement;
    esm.hidden = false; document.body.classList.add('tl-lock');
    requestAnimationFrame(function () { requestAnimationFrame(function () { esm.classList.add('is-on'); }); });
    var first = $('input,select,textarea', form); if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) {} }, 350);
  }
  function checkoutFallback(why) {
    if (window.console) console.warn('[Titan] ' + why + ' Se usa el checkout de Shopify.');
    var f = $('[data-tl-rsi-anchor] form');
    if (f) { if (f.requestSubmit) f.requestSubmit(); else f.submit(); }
  }
  function initCod() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-tl-cod],[data-tl-es]'); if (!btn || btn.disabled) return;
      var wantsEs = btn.hasAttribute('data-tl-es'), wantsRsi = btn.hasAttribute('data-tl-cod');
      closeSheet();
      // EasySell en modo incrustado: abrimos su formulario en una ventana del tema
      if (wantsEs) { var emb = esEmbedded(); if (emb) { e.preventDefault(); e.stopImmediatePropagation(); esmOpen(emb); return; } }
      // EasySell en modo ventana emergente: su app ya escucha este clic (clase oficial). No hacemos nada más.
      if (wantsEs && easyActive()) return;
      if (btn._tlBusy) return;
      e.preventDefault();
      if (wantsRsi && rsiOpen()) return;
      btn._tlBusy = true; btn.classList.add('is-loading');
      var tries = 0;
      (function go() {
        if (wantsRsi) { var b = rsiButton(); if (b) { done(); b.click(); return; } }
        if (wantsEs && esEmbedded()) { done(); esmOpen(esEmbedded()); return; }
        if (wantsEs && easyActive()) { done(); btn.click(); return; } // EasySell terminó de cargar: repetimos el toque
        // Las apps cargan un poco después que la página: reintentamos hasta 4 s
        if (++tries < 20) { setTimeout(go, 200); return; }
        done();
        checkoutFallback('No encontré EasySell ni Releasit activos en este tema (Incrustaciones de aplicaciones).');
      })();
      function done() { btn.classList.remove('is-loading'); setTimeout(function () { btn._tlBusy = false; }, 50); }
    });
  }

  function initScope(scope) { initHero(scope); initStageBg(scope); initTicker(scope); initBA(scope); initReveal(scope); initCreators(scope); checkSticky(); }

  function boot() {
    initScope(document);
    initSheetOnce();
    initCod();
    window.addEventListener('scroll', function () { requestAnimationFrame(function () { checkSticky(); updProgress(); }); }, { passive: true });
    window.addEventListener('resize', updProgress);
    updProgress();

    /* ---- Editor de Shopify ---- */
    document.addEventListener('shopify:section:load', function (e) { initScope(e.target); resyncTickers(); });
    document.addEventListener('shopify:section:unload', function (e) { cleanup(e.target); setTimeout(resyncTickers, 0); });
    document.addEventListener('shopify:section:select', function (e) {
      var bar = $('[data-tl-stk]', e.target); if (bar) { bar.classList.add('tl-force'); checkSticky(); }
      if ($('[data-tl-sheet]', e.target)) { /* no abrir sola: solo se abre al tocar */ }
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      var bar = $('[data-tl-stk]', e.target); if (bar) { bar.classList.remove('tl-force'); checkSticky(); }
    });
    document.addEventListener('shopify:block:select', function (e) {
      var hero = $('[data-tl-hero]', e.target.closest('.shopify-section') || document);
      if (hero && hero._tlGo && hero.contains(e.target)) { hero._tlGo(e.target); return; }
      var ba = e.target.closest ? e.target.closest('[data-tl-ba]') : null;
      if (ba && ba._tlGo && ba._tlGo(e.target)) return;
      var igs = e.target.closest('[data-tl-igs]'); if (igs && igs._tlGo) igs._tlGo(e.target);
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var hero = $('[data-tl-hero]', e.target.closest('.shopify-section') || document);
      if (hero && hero._tlResume) hero._tlResume();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
